import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "emoji-unamused",
  "use": "emoji-unamused-usage",
  "viewBox": "0 0 88 88",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 88 88\" id=\"emoji-unamused\">\n  <rect x=\"18\" y=\"35\" width=\"18\" height=\"6\" />\n  <rect x=\"36\" y=\"59\" width=\"18\" height=\"6\" />\n  <rect x=\"52\" y=\"35\" width=\"18\" height=\"6\" />\n  <rect x=\"30\" y=\"41\" width=\"6\" height=\"6\" />\n  <rect x=\"30\" y=\"65\" width=\"6\" height=\"6\" />\n  <rect x=\"64\" y=\"41\" width=\"6\" height=\"6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol